<template>
    <div class="image-upload">
        <div v-if="!response" class="no-answer">
            <span>
                Not Answered
            </span>
        </div>
        <div v-else-if="!response.image_url" class="no-answer">
            <span>
                No Image Added
            </span>
        </div>
        <div class="response-image" v-if="response && response.image_url">
            <a class="image-holder" :href="response.image_url" target="_blank">
                <img :src="getImages" />
            </a>
            <a class="open-icon" :href="getImages" target="_blank">
                <OpenNewIcon></OpenNewIcon>
            </a>
        </div>
        <div v-if="response && response.image_description">
            <span class="choice answer" >
                {{ response.image_description }}
            </span>
        </div>
        
    </div>
</template>

<script>

import Icons from '../icon'

export default {
    name: 'image-upload-partial',

    props: {
        // Content object for this question
		question: {
			type: Object,
			required: true
		},
		response: {
			type: [Array, Object]
		},
    },

    computed: {
        getImages() {
            try {
                return this.response.image_url.includes('.heic') ? this.response.image_url.replace('.heic', '.jpeg').replace('cdn', 'xxhdpi') : this.response.image_url
            } catch (error) {
                return ''
            }
        }
    },

    components: {
        ...Icons
    }

}
</script>

<style lang="scss" scoped>
@import "../style.scss";
.open-icon {

}
</style>